module.exports = __webpack_public_path__ + "img/94bab.ee26adb2.svg";